import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReasonsRoutingModule } from './reasons-routing.module';
import { ReasonListComponent } from './reason-list/reason-list.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CoreModule } from 'src/app/core/core.module';
import { ReasonCreateOrUpdateComponent } from './reason-create-or-update/reason-create-or-update.component';
import { ReasonViewModalComponent } from './reason-view-modal/reason-view-modal.component';
import { ReplicateReasonComponent } from './replicate-reason/replicate-reason.component';
import { ReasonListV2Component } from './v2/reason-list-v2/reason-list-v2.component';
import { ReasonCreateOrUpdateV2Component } from './v2/reason-create-or-update-v2/reason-create-or-update-v2.component';
import { ReasonViewModalV2Component } from './v2/reason-view-modal-v2/reason-view-modal-v2.component';
import { ReasonListContainerComponent } from './reason-list-container/reason-list-container.component';

@NgModule({
  declarations: [
    ReasonListComponent,
    ReasonCreateOrUpdateComponent,
    ReasonViewModalComponent,
    ReplicateReasonComponent,
    ReasonListV2Component,
    ReasonCreateOrUpdateV2Component,
    ReasonViewModalV2Component,
    ReasonListContainerComponent
  ],
  imports: [
    CommonModule,
    ReasonsRoutingModule,
    CommonModule,
    SharedModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule
  ],
  entryComponents: [
    ReasonCreateOrUpdateComponent,
    ReplicateReasonComponent,
    ReasonCreateOrUpdateV2Component,
    ReasonViewModalV2Component
  ]
})
export class ReasonsModule { }
